import { DataEdge } from './DataEdge';
import { TimeConstraintEdge } from './TimeConstraintEdge';
import { WFBEdge } from './WFBEdge';
import {
  DATA_DEPENDENCY_EDGE,
  LABWARE_DEPENDENCY_EDGE,
  TASK_DEPENDENCY_EDGE,
  TIME_CONSTRAINT_EDGE,
} from '../../../constants';
import TaskDependencyEdge from '../TaskDependencyEdge';

export const edgeTypes = {
  [LABWARE_DEPENDENCY_EDGE]: WFBEdge,
  [TIME_CONSTRAINT_EDGE]: TimeConstraintEdge,
  [DATA_DEPENDENCY_EDGE]: DataEdge,
  [TASK_DEPENDENCY_EDGE]: TaskDependencyEdge,
};
